<template>
  <asc-user-management-grid-wrapper
    :values="values"
    :airline-lengths="airlineLengths"
    :grid-columns="gridColumns"
    :grid-filters="gridFilters"
    :on-open="onOpen"
    :add-user="addUser"
    :disabled="disabled"
  ></asc-user-management-grid-wrapper>
</template>

<script>
import AscUserManagementGridWrapper from '@/components/organisms/AscUserManagementGridWrapper'
import { AscRangeDatePickerMixin, AscGridPropsMixin } from '@/components/mixins'

export default {
  name: 'AscUserManagementTemplate',

  components: {
    AscUserManagementGridWrapper,
  },

  mixins: [AscGridPropsMixin, AscRangeDatePickerMixin],

  props: {
    addUser: {
      type: Function,
      default: () => {},
    },
    airlineLengths: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
